<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Add New Case</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <form #f="ngForm" class="ion-padding" (ngSubmit)="save()">
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-list>
            <ion-item color="lightmimbo">
              <div>
                <ion-text><b> {{fullName}}</b></ion-text>
              </div>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="email" label="Email" labelPlacement="floating" [(ngModel)]="email" required
                disabled="true" class="email" type="email"></ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <div class="countrycode">
                <ion-img (click)="changeCountryCode()" [src]="codeImage"></ion-img>
                <ion-icon name="caret-down-outline"></ion-icon>
                <input type="hidden" [value]="selectedCode" />
              </div>
              <ion-input class="phonenumber" type="phone" name="phone" [(ngModel)]="phoneNumber" required type="tel"
                placeholder="Phone Number*">
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-select interface="action-sheet" required name="caseType" [(ngModel)]="caseType" label="Case Type*"
                labelPlacement="floating">
                <ion-select-option value="adoption">For Adoption</ion-select-option>
                <ion-select-option value="lost">Lost Pet</ion-select-option>
                <ion-select-option value="found">Found Pet</ion-select-option>
                <ion-select-option value="foster">Foster Needed</ion-select-option>
                <ion-select-option value="cashdonation">Cash Donation Needed</ion-select-option>
                <ion-select-option value="report">Cruelty Report</ion-select-option>
                <ion-select-option value="other">Other</ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="region" label="Region*" labelPlacement="floating" [(ngModel)]="region" required>
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="dogName" label="Name (If Known)" labelPlacement="floating" [(ngModel)]="dogName">
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="breed" label="Breed (If Known)" labelPlacement="floating" [(ngModel)]="breed">
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="age" label="Age (Years)" labelPlacement="floating" [(ngModel)]="age" type="number">
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-select required label="Size" labelPlacement="floating" name="size" [(ngModel)]="size"
                value="unknown">
                <ion-select-option value="unknown">Unknown</ion-select-option>
                <ion-select-option value="small">Small</ion-select-option>
                <ion-select-option value="medium">Medium</ion-select-option>
                <ion-select-option value="large">Large</ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-select required label="Gender" labelPlacement="floating" name="gender" [(ngModel)]="gender"
                value="unknown">
                <ion-select-option value="unknown">Unknown</ion-select-option>
                <ion-select-option value="male">Male</ion-select-option>
                <ion-select-option value="female">Female</ion-select-option>
              </ion-select>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-input name="medical" [(ngModel)]="medical" label="Medical Issues (If Known)"
                labelPlacement="floating">
              </ion-input>
            </ion-item>
            <ion-item color="lightmimbo">
              <ion-textarea [(ngModel)]="details" label="Case Details*" labelPlacement="floating" name="details"
                rows="10" placeholder="Share with us the information you have about this case"
                required></ion-textarea></ion-item>
          </ion-list>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
          <ion-button (click)="addImage()" [disabled]="images.length>4"><ion-icon name="camera-outline"
              slot="start"></ion-icon> Add Image
            <br /></ion-button>
        </ion-col>
      </ion-row>
      <ion-row><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <div *ngIf="images.length >0">
            <div *ngFor="let image of images;index as i" class="image-wrap">
              <ion-icon name="trash-outline" class="close" (click)="removePhoto(i)"></ion-icon>
              <ion-img ion-item [src]="image" class="uploaded-images"></ion-img>
            </div>
          </div>
          <div *ngIf="images.length ===0">
            <ion-text color="danger">Upload at least one picture to save. (Up to 5 images)</ion-text>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text>I've read and accept the
            <ion-label id="terms-modal" color="primary" class="pointer"><b>Terms of Service</b></ion-label></ion-text>
          <ion-checkbox (ionChange)="toggleMessage()" name="termsAccepted" [(ngModel)]="termsAccepted"
            style="float: right"></ion-checkbox>
        </ion-col>
      </ion-row>
      <ion-row><ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2"><ion-text color="danger"
            *ngIf="!hideTermsMessage"><small><i>You must accept terms and conditions to
                continue</i></small></ion-text></ion-col></ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
          <ion-button color="primary" (click)="openOTP()" [disabled]="!f.valid || images.length===0"><ion-icon
              name="save" slot="start"></ion-icon>Add Case</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
  <ion-modal trigger="terms-modal" #termsModal>
    <ng-template>
      <ion-header>
        <ion-toolbar color="primary">
          <ion-buttons slot="start">
            <ion-button (click)="cancel()"><ion-icon name="arrow-back-outline" slot="icon-only">
              </ion-icon></ion-button>
          </ion-buttons>
          <ion-title>Terms & Conditions</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content color="lightmimbo">
        <ion-grid>
          <ion-row>
            <ion-col>
              <h1>Terms and Conditions</h1>
              <h2>1. Submission of Form</h2>
              <p>
                By submitting this form, you agree to comply with the terms and
                conditions outlined herein. If you do not agree with these
                terms, please do not submit the form.
              </p>

              <h2>2. Data Privacy</h2>
              <h3>2.1 Data Collection</h3>
              <p>
                We collect and store the information provided in this form,
                including your name and phone number, for the purpose of
                facilitating communication between users.
              </p>

              <h3>2.2 Data Usage</h3>
              <p>
                Your information will be used solely for the purpose of allowing
                other users to contact you as specified in this form.
              </p>

              <h3>2.3 Data Security</h3>
              <p>
                We take data security seriously and employ industry-standard
                measures to protect your information. However, please be aware
                that no online data transmission or storage is entirely secure,
                and we cannot guarantee the absolute security of your
                information.
              </p>

              <h3>2.4 Data Retention</h3>
              <p>
                Your information will be retained for as long as necessary to
                fulfill the intended purpose or as required by applicable laws
                and regulations.
              </p>

              <h2>3. Consent to Share Information</h2>
              <p>
                By submitting this form, you consent to the sharing of your name
                and phone number with other users of our platform for the
                purpose of communication.
              </p>

              <h2>4. Changes to Terms and Conditions</h2>
              <p>
                We reserve the right to update or modify these terms and
                conditions at any time. You are responsible for reviewing this
                page periodically to ensure you are aware of any changes.
              </p>

              <h2>5. Contact Information</h2>
              <p>
                If you have any questions or concerns about these terms and
                conditions, please contact us at
                <a href="mailto:adminsupport@mimboapp.com">adminsupport&#64;mimboapp.com</a>.
              </p>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>